import React, { useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Typography } from '@mui/material';
import { LoadingButton } from "@mui/lab";

import { Utils } from "common/Utils";

import { useTheme } from '@mui/material/styles';

import { PrivateRoutesContext } from "app/PrivateRoutesContext";

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import BrdDocumentLink from "components/Button/BrdDocumentLink";

export default function BrdAcknowledgementDialog({doShow, acknowledgement, handleSubmit, handleClose}) {
    const { userInfo } = useContext(PrivateRoutesContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isDeferring, setIsDeferring] = useState(false);
    const [isBRDAcknowledged, setIsBRDAcknowledged] = useState(false);

    const isAcknowledged = useMemo(() => {
        return (acknowledgement && acknowledgement.user && acknowledgement.date) != null;
    }, [acknowledgement]);
    
    const canAcknowledge = useMemo(() => {
        return Utils.isEmployer(userInfo);
      },[userInfo]);

    useEffect(() => {
        if (!isAcknowledged) {
            setIsBRDAcknowledged(false);
        }
    },[doShow, isAcknowledged]);

    const theme = useTheme();

    const onSubmit = () => {
        setIsSubmitting(true);

        handleSubmit(true, () => setIsSubmitting(false));
    }

    const onDefer = () => {
        setIsDeferring(true);

        handleSubmit(false, () => setIsDeferring(false));
    }

    return (
      <Dialog
        open={doShow}
        maxWidth={false}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle textAlign="center">
            Business Requirements Document Acknowledgement
        </DialogTitle>
        <DialogContent>
          <Box className="container">
            <Box className="row">
              <Box className="col-12">
                <FormControlLabel 
                    control={
                        <Checkbox
                            checked={isBRDAcknowledged || isAcknowledged}
                            onClick={() => setIsBRDAcknowledged(!isBRDAcknowledged)}
                            disabled={isAcknowledged || !canAcknowledge}
                        />
                    }
                    label="I have validated the Business Requirements Document (BRD) for data accuracy and will sign off"
                />
              </Box>
              <Box className="col-12" sx={{ textAlign: "end" }}>
                <BrdDocumentLink />
              </Box>
              {isAcknowledged ?
              <Box className="col-12">
                <Typography align="right">
                  {`Acknowledged by ${acknowledgement.user} on ${Utils.formatDate(acknowledgement.date)}`}
                </Typography>
              </Box> : null}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
            {isAcknowledged || !canAcknowledge ?
                <Button variant="outlined" color="primary" onClick={handleClose}>
                    Close
                </Button>
            :
                <>
                    <LoadingButton
                        variant="outlined"
                        color="primary"
                        onClick={onSubmit}
                        startIcon={<CheckIcon />}
                        loading={isSubmitting}
                        loadingPosition="start"
                        disabled={!isBRDAcknowledged || isDeferring}
                    >
                        Submit
                    </LoadingButton>
                    <LoadingButton
                        variant="outlined"
                        color="primary"
                        onClick={onDefer}
                        startIcon={<CloseIcon />}
                        loading={isDeferring}
                        loadingPosition="start"
                        disabled={isSubmitting}
                    >
                        Defer
                    </LoadingButton>
                </>
            }
        </DialogActions>
      </Dialog>
    )
}